import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { ContentClickedEventHandler } from '../../../common/telemetryEvents/types/ContentTelemetryTypes';
import { mouseUpFactory } from '../../../common/telemetryEvents/util/EventHandlerFactories';
import { L10n } from '../../../ts/L10n/L10n';
import { DataSources } from '../../../content/resources/Datasources';
import { telemetryConsumerWrapper } from '../../contexts/TelemetryConsumerWrapper';
import { ContentClickedTelemetryContext } from '../../contexts/TelemetryContexts';
import { SiteUrlsProps } from '../../selectors/SiteUrlsSelectors';
import { CommonDatasourceInfo } from '../CommonDatasourceInfo';
import { CardViewStyles } from './CardViewStyles';
import { ExtractEncryptionMode } from '../../../sites/SitePropertyTypes';

export interface DetailedDatasourceThumbnailOwnProps {
  readonly datasource: CommonDatasourceInfo;
  readonly contentUrl: string;
  readonly showExtractEncryptionStatus: boolean;
  readonly allowDragAndDrop: boolean;
  readonly hoveredOrSelected?: boolean;
  readonly ariaLabel?: string;
}

export interface DetailedDatasourceThumbnailStateProps {
  readonly siteEARMode: ExtractEncryptionMode;
}

export type DetailedDatasourceThumbnailProps =
  SiteUrlsProps & DetailedDatasourceThumbnailOwnProps & DetailedDatasourceThumbnailStateProps;

export class DetailedDatasourceThumbnail extends React.Component<DetailedDatasourceThumbnailProps> {
  public render() {
    const containerClass = this.props.hoveredOrSelected ?
      (this.props.contentUrl ? CardViewStyles.CustomThumbnailHover : CardViewStyles.CustomThumbnailHoverNoPointer)
      : CardViewStyles.CustomThumbnail;
    /* eslint-disable jsx-a11y/alt-text */
    return (
      <div className={containerClass}>
        <div>
          <div className={CardViewStyles.CustomThumbnailTopContainer}>
            <div className={CardViewStyles.DatasourceCustomThumbnailImg}>
                <img
                  src={DataSources.getIconForDatasourceType(this.props.datasource, 'card')}
                  width={'60px'} height={'60px'}
                  data-tb-test-id={DataSources.isCertified(this.props.datasource) ? 'certification-icon' : ''}/>
            </div>
            <div>
            {DataSources.DatasourceStatus(this.props.showExtractEncryptionStatus,this.props.datasource.connectionType,this.props.datasource.isFileBased, DataSources.isExtract(this.props.datasource), this.props.datasource.extractEncryptionState, this.props.datasource.extractCreationPending, this.props.siteEARMode)}
            </div>
          </div>
          <div>
            {this.lastRefreshTime()}
          </div>
        </div>
        {this.props.contentUrl &&
          telemetryConsumerWrapper(ContentClickedTelemetryContext.Consumer, (sendOpenContentTelemetry: ContentClickedEventHandler) =>
            /* eslint-disable jsx-a11y/anchor-has-content */
            <a
              onMouseUp={mouseUpFactory<HTMLAnchorElement>(sendOpenContentTelemetry)}
              href={this.props.contentUrl}
              className={CardViewStyles.AnchorUnderlay}
              /**
               * If card reordering allowed, disable link dragging.
               * Otherwise, set `draggable` explicitly to undefined rather than true.
               * (When `draggable` is true, the browser-provided drag avatar looks too similar
               * to the reorder card feature's avatar, which may confuse users.)
               */
              draggable={this.props.allowDragAndDrop ? false : undefined}
              aria-label={this.props.ariaLabel}
            ></a>
          )
        }
      </div>
    );
  }

  private lastRefreshTime = (): JSX.Element => {
    const dateTime = this.props.datasource.lastRefreshedAt;
    return dateTime ? <span>{Messages.lastRefresh()} {L10n.localizedDateTime(dateTime)}</span> : <span>&nbsp;</span>;
  }
}
